import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'

export function fillFormItemProps(field: SchemaField): string {
  return formItemProps(field, field.height === 'fill' ? 'flex flex-col' : undefined)
}
